module.exports = __webpack_public_path__ + "static/media/exchange-banner-img1.8718a5d5.svg";